"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _lodash = require("lodash");
var _Form = _interopRequireDefault(require("./components/Form"));
var _utils = require("./utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var FormRenderer = /*#__PURE__*/function (_PureComponent) {
  _inherits(FormRenderer, _PureComponent);
  var _super = _createSuper(FormRenderer);
  function FormRenderer(props) {
    var _this;
    _classCallCheck(this, FormRenderer);
    _this = _super.call(this, props);
    _this.initialize = _this.initialize.bind(_assertThisInitialized(_this));
    _this.onSubmit = _this.onSubmit.bind(_assertThisInitialized(_this));
    _this.onSubmitFail = _this.onSubmitFail.bind(_assertThisInitialized(_this));
    _this.conditionalDisplay = _this.conditionalDisplay.bind(_assertThisInitialized(_this));
    _this.reset = _this.reset.bind(_assertThisInitialized(_this));
    _this.submit = _this.submit.bind(_assertThisInitialized(_this));
    _this.submitPromise = null;
    _this.state = {
      hiddenFields: []
    };
    return _this;
  }
  _createClass(FormRenderer, [{
    key: "onSubmit",
    value: function onSubmit(data) {
      var formatedData = (0, _utils.formatData)(this.props.formData, data);
      this.props.onSubmit(formatedData);
      this.resolveSubmit(formatedData);
    }
  }, {
    key: "onSubmitFail",
    value: function onSubmitFail(errors) {
      this.props.onSubmitFail(errors);
      this.rejectSubmit(errors);
    }
  }, {
    key: "conditionalDisplay",
    value: function conditionalDisplay(values) {
      this.setState({
        hiddenFields: (0, _utils.conditionalDisplay)(this.props.formData, values)
      });
      return undefined;
    }
    /**
     * Calls the intialize action creator of redux-form
     * @public
    */
  }, {
    key: "initialize",
    value: function initialize() {
      var _this$props = this.props,
        dispatch = _this$props.dispatch,
        formData = _this$props.formData;
      var newValues = (0, _utils.getInitialValues)(formData);
      dispatch((0, _reduxForm.initialize)(formData.id, newValues));
    }
    /**
     * Calls the reset action creator of redux-form
     * @public
    */
  }, {
    key: "reset",
    value: function reset() {
      var _this$props2 = this.props,
        dispatch = _this$props2.dispatch,
        id = _this$props2.formData.id;
      dispatch((0, _reduxForm.reset)(id));
    }
    /**
     * Calls the submit action creator of redux-form.
     * It return a Promise resolving with the form data or rejecting with the form errors
     * @public
    */
  }, {
    key: "submit",
    value: function submit() {
      var _this2 = this;
      var _this$props3 = this.props,
        dispatch = _this$props3.dispatch,
        id = _this$props3.formData.id;
      this.submitPromise = new Promise(function (resolve, reject) {
        _this2.resolveSubmit = resolve;
        _this2.rejectSubmit = reject;
      });
      dispatch((0, _reduxForm.submit)(id));
      return this.submitPromise;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        editMode = _this$props4.editMode,
        formData = _this$props4.formData,
        getFormState = _this$props4.getFormState;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "ui-form-renderer"
      }, /*#__PURE__*/_react["default"].createElement(_Form["default"], {
        formData: formData,
        validate: this.conditionalDisplay,
        hiddenFields: this.state.hiddenFields,
        getFormState: getFormState,
        onSubmit: this.onSubmit,
        onSubmitFail: this.onSubmitFail,
        editMode: editMode
      }));
    }
  }]);
  return FormRenderer;
}(_react.PureComponent);
FormRenderer.propTypes = {
  /** the redux dispatch passed by connect */
  dispatch: _propTypes["default"].func.isRequired,
  /** is the form in edit mode or display mode? */
  editMode: _propTypes["default"].bool,
  /** the form configuration object */
  formData: _propTypes["default"].object,
  /**
   * function to return the right state part when the form reducer is not mounted on `form`
   * @param {object} state
  */
  getFormState: _propTypes["default"].func,
  /**
   * submit callback being called when the form successfully submits
   * @param {object} data the form data
  */
  onSubmit: _propTypes["default"].func,
  /**
   * submit callback being called when the form fails submit
   * @param {object} errors the form errors
  */
  onSubmitFail: _propTypes["default"].func
};
FormRenderer.defaultProps = {
  editMode: true,
  formData: {},
  inline: false,
  getFormState: function getFormState(state) {
    return state.form;
  },
  onSubmit: _lodash.noop,
  onSubmitFail: _lodash.noop
};
var _default = exports["default"] = (0, _reactRedux.connect)(null, null, null, {
  withRef: true
})(FormRenderer);